import {ref} from 'vue';

interface MessageObjI {
    title: string;
    message: string;
    acceptBtnName?: string;
    denyBtnName?: string;
    autoCloseRejected?: boolean;
}

export type alertHandler = (
    message:
        | string
        | {
              title: string;
              message: string;
          },
    callback?: Function,
) => void;

export type confirmHandler = (
    message:
        | string
        | {
              title: string;
              message: string;
              acceptBtnName?: string;
              denyBtnName?: string;
              autoCloseRejected?: boolean;
          },
    callback?: Function,
    cancelCallback?: Function,
) => void;

export type toastHandler = (message: string, callback?: Function) => void;

export default function useMessage() {
    const globalAlertOpened = ref(false);
    const globalAlertTitle = ref('');
    const globalAlertMessage = ref('');
    const globalAlertCallback = ref<Function | null>(null);

    const globalConfirmOpened = ref(false);
    const globalConfirmTitle = ref('');
    const globalConfirmMessage = ref('');
    const globalConfirmCallback = ref<Function | null>(null);
    const globalConfirmAcceptBtnName = ref<any>('');
    const globalConfirmDenyBtnName = ref<any>('');
    const globalConfirmCancelCallback = ref<Function | null>(null);

    const globalToastVisible = ref(false);
    const globalToastMessage = ref('');
    const globalToastCallback = ref<Function | null>(null);

    const customAlert = (payload: string | MessageObjI, callback?: any) => {
        if (typeof payload === 'string') {
            globalAlertMessage.value = payload;
        } else {
            globalAlertTitle.value = payload.title;
            globalAlertMessage.value = payload.message;
        }
        globalAlertCallback.value = callback;
        globalAlertOpened.value = true;
    };

    const customConfirm = (
        payload: string | MessageObjI,
        callback?: any,
        cancelCallback?: any,
    ) => {
        if (typeof payload === 'string') {
            globalConfirmMessage.value = payload;
            globalConfirmAcceptBtnName.value = '확인';
            globalConfirmDenyBtnName.value = '취소';
        } else {
            globalConfirmTitle.value = payload.title;
            globalConfirmMessage.value = payload.message;
            globalConfirmAcceptBtnName.value = payload.acceptBtnName;
            globalConfirmDenyBtnName.value = payload.denyBtnName;
        }
        globalConfirmCallback.value = callback;
        globalConfirmCancelCallback.value = cancelCallback;
        globalConfirmOpened.value = true;
    };

    const customToast = (payload: string, callback?: any) => {
        globalToastVisible.value = true;
        if (typeof payload === 'string') {
            globalToastMessage.value = payload;
        }
        globalToastVisible.value = true;
        globalToastCallback.value = callback;
    };

    const closeAlert = () => {
        if (typeof globalAlertCallback.value == 'function') {
            globalAlertCallback.value();
        }
        globalAlertOpened.value = false;
        globalAlertTitle.value = '';
        globalAlertMessage.value = '';
        globalAlertCallback.value = null;
    };

    const acceptConfirm = () => {
        if (typeof globalConfirmCallback.value == 'function') {
            globalConfirmCallback.value();
        }
        resetConfirm();
    };

    const closeConfirm = () => {
        if (typeof globalConfirmCancelCallback.value == 'function') {
            globalConfirmCancelCallback.value();
        }
        resetConfirm();
    };

    const resetConfirm = () => {
        globalConfirmOpened.value = false;
        globalConfirmTitle.value = '';
        globalConfirmMessage.value = '';
        globalConfirmCallback.value = null;
        globalConfirmAcceptBtnName.value = '';
        globalConfirmDenyBtnName.value = '';
        globalConfirmCancelCallback.value = null;
    };

    const closeToast = () => {
        globalToastVisible.value = false;
        globalToastMessage.value = '';
    };

    const afterToast = () => {
        if (typeof globalToastCallback.value == 'function') {
            globalToastCallback.value();
        }
    };

    if (!window.customAlert) {
        window.customAlert = customAlert;
    }

    if (!window.customConfirm) {
        window.customConfirm = customConfirm;
    }

    if (!window.customToast) {
        window.customToast = customToast;
    }

    return {
        closeAlert,
        acceptConfirm,
        closeConfirm,
        closeToast,
        afterToast,
        globalAlertOpened,
        globalAlertTitle,
        globalAlertMessage,
        globalAlertCallback,
        globalConfirmOpened,
        globalConfirmTitle,
        globalConfirmMessage,
        globalConfirmAcceptBtnName,
        globalConfirmDenyBtnName,
        globalConfirmCallback,
        globalConfirmCancelCallback,
        globalToastVisible,
        globalToastMessage,
        globalToastCallback,
    };
}
